
















import { Component, Vue } from 'vue-property-decorator';

import Layout from '@/layouts/Default.vue';
import EditLayout from '../EditLayout.vue';

import CPBtn from '@/components/buttons/CPBtn/CPBtn.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';
import { editTabsNav } from '@/store/patients/tabs';
import { syncPatientLoyaltyCards } from '@/api/loyalty-cards';
import LoyaltyCardsModule from "@/store/patients/loyaltyCards";

@Component({
    components: {
        Layout,
        EditLayout,
        CPBtn,
        ListBlock,
    },
})
export default class PatientsLoyaltyCardsPage extends Vue {
    repository = LoyaltyCardsModule;

    get tabsNav() {
        return editTabsNav;
    }

    get currentTab() {
        const tabs = Object.values(this.tabsNav);
        const currentTab = tabs.find(tab => tab.pathName === this.$route.name);

        return currentTab?.id ?? '';
    }

    get patientId() {
        return this.$route.params.patientsId;
    }

    get filterSettings() {
        return LoyaltyCardsModule.filter.filterSettings;
    }

    async toSync() {
        try {
            await syncPatientLoyaltyCards(this.patientId);
            await this.resetFilters();
        } catch (clientError: any) {
            const error = clientError.response.data

            throw new Error(error.message);
        }
    }

    async updateList() {
        await LoyaltyCardsModule.filter.updateFilter();
        await LoyaltyCardsModule.getList();
    }

    async resetFilters() {
        await LoyaltyCardsModule.clearSort();
        await LoyaltyCardsModule.filter.resetFilter();
        await LoyaltyCardsModule.setPatientId(this.patientId);
        await LoyaltyCardsModule.getList();
    }

    async created() {
        await LoyaltyCardsModule.setPatientId(this.patientId);
    }

    beforeDestroy() {
        LoyaltyCardsModule.clearList()
    }
}
